import React, { useState, useEffect } from "react";
import '../css/timeline.css';
import estrela from '../image/estrela3d.png';

const timelineData = [
    { 
        id: 1, 
        title: "Fábrica de Projetos Ágeis", 
        description: "Onde tudo começou. Desenvolvemos a ideia inicial usando métodos ágeis para entender as necessidades reais das instituições de ensino e criar nossa proposta de valor." 
    },
    { 
        id: 2, 
        title: "Programa Empreendedorismo", 
        description: "Aprendemos a transformar nossa ideia em um negócio real. Desenvolvemos o plano comercial, estratégias de vendas e como apresentar o projeto para potenciais investidores, tudo isso com o apoio do SEBRAE." 
    },
    { 
        id: 3, 
        title: "Desenvolvimento Empresarial", 
        description: "Estruturação do negócio para crescer. Montamos a equipe certa, com as habilidades necessárias, definimos metas, métricas de acompanhamento e estratégias para expandir nossa operação." 
    },
    { 
        id: 4, 
        title: "Incubação Unimar", 
        description: "Fase de estruturação da startup. Com apoio da incubadora, conseguimos nosso primeiro espaço, mentores especializados e os primeiros investimentos para tirar o projeto do papel." 
    },
    { 
        id: 5, 
        title: "Desenvolvimento Técnico", 
        description: "Foco em construir uma plataforma estável e segura. Estamos criando a versão inicial do produto, preparando testes com escolas parceiras e professores, melhorando com base no feedback recebido."
    },
    { 
        id: 6, 
        title: "Comercialização", 
        description: "Levar o produto para o mercado. Começamos a vender para escolas em várias regiões do país, fechando parcerias importantes e ajudando instituições de ensino a melhorar seus processos."
    }
];

const desktopOrder = [0, 2, 4, 1, 3, 5];

const Timeline = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const renderItems = () => {
        if (isMobile) {
            return (
                <div className="timeline-mobile">
                    {timelineData.map(item => renderItem(item))}
                </div>
            );
        } else {
            return (
                <>
                    <div className="timeline-row top-row">
                        {desktopOrder.slice(0, 3).map(index => 
                            renderItem(timelineData[index])
                        )}
                    </div>
                    <div className="timeline-row bottom-row">
                        {desktopOrder.slice(3, 6).map(index => 
                            renderItem(timelineData[index])
                        )}
                    </div>
                </>
            );
        }
    };

    const renderItem = (item) => (
        <div key={item.id} className={`timeline-item ${item.id === 5 ? 'gradient-border' : ''}`}>
            {item.id === 5 && <img src={estrela} alt="Estrela" className="star-icon" />}
            <div className="timeline-content">
                <h2>
                    <span className="item-number">#{item.id}</span>
                    {item.title}
                </h2>
                <p>{item.description}</p>
            </div>
        </div>
    );

    return (
        <div className="timeline-container">
            {!isMobile}
            {renderItems()}
        </div>
    );
};

export default Timeline;